import { apiClient } from "../../../lib";

export const procurementPipelineApi = {
    fetchMaterialTrendStatistics: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/material-request/trend-statistics?${queryString}`);
        return response.data;
    },

    fetchResourceTrendStatistics: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/resource-request/trend-statistics?${queryString}`);
        return response.data;
    },

    fetchMaterialDelayStatistics: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/material-request/delay-statistics?${queryString}`);
        return response.data;
    },

    fetchResourceDelayStatistics: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/resource-request/delay-statistics?${queryString}`);
        return response.data;
    },

    fetchMaterialStatistics: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/material-request/statistics?${queryString}`);
        return response.data;
    },

    fetchResourceStatistics: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/resource-request/statistics?${queryString}`);
        return response.data;
    },

    // New API calls for lead time statistics
    fetchMaterialLeadTimeStatistics: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/material-request/lead-time-statistics?${queryString}`);
        return response.data;
    },

    fetchResourceLeadTimeStatistics: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/resource-request/lead-time-statistics?${queryString}`);
        return response.data;
    }
    
};